import Default from './default'
import Theme1 from './theme1'
import Theme2 from './theme2'
import Brew from "./brew";

// ==============================|| PRESET THEME - THEME SELECTOR ||============================== //

export default function Theme(colors, presetColor, mode) {
	switch (presetColor) {
		case 'Theme1':
			return Theme1(colors, mode)
		case 'Theme2':
			return Theme2(colors, mode)
		case 'Brew':
			return Brew(colors, mode);
		default:
			return Default(colors)
	}
}
